// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/pages/LoginPage.vue'
import { useAuthStore } from '@/stores/auth.js'
import AppPage from '@/pages/AppPage.vue'
import UsuariosPage from '@/pages/UsuariosPage.vue'
import ParceriasPage from '@/pages/ParceriasPage.vue'
import ModulosPage from '@/pages/ModulosPage.vue'
import PlanosPage from '@/pages/PlanosPage.vue'
import CalculadoraComercialPage from '@/pages/CalculadoraComercialPage.vue'

const routes = [
  {
    path: '/',
    name: 'LoginPage',
    component: LoginPage
  },
  {
    path: '/app',
    name: 'AppPage',
    component: AppPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/usuarios',
    name: 'UsuariosPage',
    component: UsuariosPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/parcerias',
    name: 'ParceriasPage',
    component: ParceriasPage,
    meta: { requiresAuthRoot: true }
  },
  {
    path: '/modulos',
    name: 'ModulosPage',
    component: ModulosPage,
    meta: { requiresAuthRoot: true }
  },
  {
    path: '/planos',
    name: 'PlanosPage',
    component: PlanosPage,
    meta: { requiresAuthRoot: true }
  },
   {
    path: '/calculadora',
    name: 'CalculadoraComercialPage',
    component: CalculadoraComercialPage,
    meta: { requiresAuth: true }
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Autenticação
router.beforeEach(async (to, from, next) => {
  const authStoreUser = useAuthStore()

  if (to.meta.requiresAuth && !authStoreUser.access_token) return next('/')

  if (to.meta.requiresAuthRoot && !authStoreUser.usuario.root) return next('/')
    
  next()

})

export default router
